import { render } from "./LoginTCInvitation.vue?vue&type=template&id=99b15276"
import script from "./LoginTCInvitation.vue?vue&type=script&lang=js"
export * from "./LoginTCInvitation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__